

/**
 * 判断是否在浏览器环境
 */
function isBrowser() {
  return process.browser
}


export default {
  isBrowser
}
